const IMAGE_DATA_URL_PATTERN = /^data:image\/(?:png|jpe?g|gif|webp|avif);base64,/i;

export const isAllowedImageSource = source => {
    if (typeof source !== "string" || !source.trim()) return false;
    if (IMAGE_DATA_URL_PATTERN.test(source.trim())) return true;

    try {
        const url = new URL(source.trim(), window.location.origin);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch {
        return false;
    }
};